import AddSkuPageBanner from './AddSkuPageBanner';

export default AddSkuPageBanner;
